import { Navigate } from "react-router-dom";
import { RouteObject } from "react-router";
import { checkPermission } from "./RouteHelper";
import {
  IAnonymousStructure,
  IAuthorizedStructure,
  IGenerateRoute,
  IAuthStructure,
  IRoute,
} from "@lib/types/Routes";
import { AuthRoles } from "@lib/types/Auth";

const generateRoutes = (structure: IGenerateRoute): RouteObject[] => {
  const {
    isAuthenticated = false,
    anonymousStructure,
    authorizedStructure,
    authStructure,
    userRole = [],
  } = structure || {};

  const dynamicRoutes: RouteObject[] = [
    ...generateRoutesForType({
      type: "anonymous",
      structure: anonymousStructure,
    }),
    ...generateRoutesForType({
      type: "authorized",
      structure: authorizedStructure,
      isConditionMet: isAuthenticated,
      userRole,
    }),
    ...generateRoutesForType({
      type: "public",
      structure: authStructure,
      isConditionMet: !isAuthenticated,
    }),
  ];

  return dynamicRoutes;
};

type GenerateRoutesForTypeProps = {
  isConditionMet?: boolean;
  userRole?: AuthRoles[];
} & (
  | {
      type: "anonymous";
      structure: IAnonymousStructure;
    }
  | {
      type: "authorized";
      structure: IAuthorizedStructure;
    }
  | {
      type: "public";
      structure: IAuthStructure;
    }
);

const generateRoutesForType = (
  props: GenerateRoutesForTypeProps,
): RouteObject[] => {
  const { type, structure, isConditionMet, userRole } = props;
  const {
    fallbackPath,
    routes = [],
    unAuthorizedComponent,
  } = structure as IAuthorizedStructure;

  if (type == "authorized" && !isConditionMet) return [];

  if (!Array.isArray(routes) || routes.length === 0) {
    console.warn(`[routes] prop is missing or empty in ${type} structure.`);
    return [];
  }

  return routes.flatMap((route: IRoute) =>
    createRoute(
      route,
      type,
      isConditionMet,
      fallbackPath,
      userRole,
      unAuthorizedComponent,
    ),
  );
};

const createRoute = (
  route: IRoute,
  type: string,
  isConditionMet: boolean,
  fallbackPath: string,
  userRole?: AuthRoles[],
  unAuthorizedComponent?: JSX.Element,
): RouteObject[] => {
  const { path = "", element, roles } = route;

  if (!path) {
    return [];
  }

  const routes: RouteObject[] = [];
  const paths = Array.isArray(path) ? path : [path];
  const hasPermission = checkPermission(roles, userRole || []);

  paths.forEach((singlePath) => {
    if (type === "anonymous") {
      routes.push({ path: singlePath, element });
    } else if (type === "authorized") {
      routes.push(
        isConditionMet
          ? hasPermission
            ? { path: singlePath, element }
            : { path: singlePath, element: unAuthorizedComponent }
          : {
              path: singlePath,
              // element: <Navigate to={redirectPath || fallbackPath} replace />,
              element: <Navigate to={fallbackPath} replace />,
            },
      );
    } else {
      // type === "public"
      routes.push(
        isConditionMet
          ? { path: singlePath, element }
          : {
              path: singlePath,
              // element: <Navigate to={redirectPath || fallbackPath} replace />,
              element: <Navigate to={"/"} replace />,
            },
      );
    }
  });

  return routes;
};

export default generateRoutes;
